import { z } from 'zod';

export const integerGreaterThanZero = () =>
  // Convert string to number before validating
  z.preprocess(
    val => {
      // Check for empty strings
      if (val !== '' && String(val).trim() === '') {
        return NaN;
      }
      // If the value is empty, return null instead of 0
      return val === '' ? null : Number(val);
    },
    z
      .number({
        invalid_type_error: 'Must be a valid number',
      })
      .int("Can't contain decimals")
      .positive('Must be greater than zero')
      .nullable(),
  );

export const requiredIntegerGreaterThanZero = () =>
  z.preprocess(
    val =>
      val === '' ||
      val === null ||
      val === undefined ||
      (typeof val === 'string' && val.trim() === '')
        ? undefined
        : Number(val),
    z
      .number({
        required_error: 'Required',
        invalid_type_error: 'Must be a valid number',
      })
      .int("Can't contain decimals")
      .positive('Must be greater than zero'),
  );

export const decimalGreaterThanZero = () =>
  // Convert string to number before validating
  z.preprocess(
    val => {
      // Check for empty strings
      if (val !== '' && String(val).trim() === '') {
        return NaN;
      }
      // If the value is empty, return null instead of 0
      return val === '' ? null : Number(val);
    },
    z
      .number({
        invalid_type_error: 'Must be a valid number',
      })
      .positive('Must be greater than zero')
      .nullable(),
  );

export const maxLengthString = (maxLength = 255) =>
  z
    .string()
    .max(maxLength, 'Your value is too long')
    .nonempty('Please enter a valid value')
    .optional()
    .or(z.literal(''));

export const requiredMaxLengthString = (maxLength = 255) =>
  z
    .string({ required_error: 'Required' })
    .trim()
    .min(1, 'Required')
    .max(maxLength, 'Your value is too long');

export const requiredNumber = () =>
  z.preprocess(
    val =>
      val === '' ||
      val === null ||
      val === undefined ||
      (typeof val === 'string' && val.trim() === '')
        ? undefined
        : Number(val),
    z.number({
      required_error: 'Required',
      invalid_type_error: 'Must be a valid number',
    }),
  );

export const requiredString = (maxLength = 255) =>
  z
    .string({ required_error: 'Required' })
    .trim()
    .min(1, 'Required')
    .max(maxLength, 'Your value is too long');
